import { render, staticRenderFns } from "./cases-dialog.vue?vue&type=template&id=39dc8d29&scoped=true&"
import script from "./cases-dialog.vue?vue&type=script&lang=ts&"
export * from "./cases-dialog.vue?vue&type=script&lang=ts&"
import style0 from "@/modules/Dashboard/styles/dashboard-dialog.scss?vue&type=style&index=0&id=39dc8d29&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39dc8d29",
  null
  
)

export default component.exports